/** Checkbox and filter-permalink clicks share the same multi-select toggle. */
export const toggleSelectedFilterId = (selectedIds: string[], itemId: string): string[] =>
  selectedIds.includes(itemId)
    ? selectedIds.filter((selectedId) => selectedId !== itemId)
    : [...selectedIds, itemId];
